import { API } from "../../../utils";

export const getPlAndBsDashboardDetailsApi = async (formData) => {
  const response = await API.get("/pl-dashboard/pl-ratios", {
    params: formData,
  });
  return response.data;
};
